/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useCustomerAuth, describeAxiosError, formatApiError } from "@/contexts/CustomerAuthContext";
import AuthShell, { Field } from "@/components/customer/AuthShell";
import SEO from "@/components/site/SEO";

export default function ForgotPassword() {
  const { forgotPassword } = useCustomerAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email.trim().toLowerCase());
      setSent(true);
    } catch (err) {
      toast.error(describeAxiosError(err, "Could not send reset link."));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Forgot your password?"
      subtitle="Enter your email and we&rsquo;ll send you a secure reset link."
      footer={<><Link to="/login" className="font-semibold text-brand-green hover:text-brand-greenHover">Back to sign in</Link></>}>
      <SEO title="Forgot password" path="/forgot-password" />
      {sent ? (
        <div data-testid="forgot-sent" className="rounded-xl border border-brand-line bg-brand-bgSoft p-6 text-sm">
          <p className="font-semibold text-brand-ink">Check your inbox.</p>
          <p className="text-brand-muted mt-2">If an account exists for that email, a password reset link is on its way. The link expires in 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form" noValidate>
          <Field label="Email" type="email" testId="forgot-email" value={email} onChange={(e)=>setEmail(e.target.value)}
                 placeholder="you@example.com" required autoComplete="email" name="email" />
          <button type="submit" disabled={loading} data-testid="forgot-submit"
                  className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-green px-6 py-3 text-sm font-semibold text-brand-ink hover:bg-brand-greenHover disabled:opacity-70">
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Sending…</> : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
